import { useState, useEffect } from 'react';
import {
  Card, Table, Tag, Button, Modal, Form, Input, InputNumber, Select, message, Progress, Row, Col, Statistic,
} from 'antd';
import { tenants } from '../../services/api';

const PLAN_COLORS = { standard: 'blue', enterprise: 'gold', trial: 'default' };

export default function TenantAdminPage() {
  const [list, setList] = useState([]);
  const [current, setCurrent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [createOpen, setCreateOpen] = useState(false);
  const [form] = Form.useForm();

  const load = async () => {
    try {
      const [listRes, curRes] = await Promise.all([
        tenants.list(),
        tenants.current(),
      ]);
      setList(listRes.data || []);
      setCurrent(curRes.data);
    } catch (err) {
      message.error(err.message || '加载失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const handleCreate = async () => {
    try {
      const values = await form.validateFields();
      await tenants.create(values);
      message.success('租户已创建');
      setCreateOpen(false);
      form.resetFields();
      load();
    } catch (err) {
      if (err.message) message.error(err.message);
    }
  };

  const columns = [
    { title: '租户名称', dataIndex: 'name' },
    { title: '编码', dataIndex: 'code' },
    { title: '套餐', dataIndex: 'plan', render: (p) => <Tag color={PLAN_COLORS[p]}>{p}</Tag> },
    { title: '园区', render: (_, r) => `${r.usage?.parks || 0}/${r.max_parks}` },
    { title: '用户', render: (_, r) => `${r.usage?.users || 0}/${r.max_users}` },
    { title: '表计', dataIndex: ['usage', 'meters'] },
    { title: '状态', dataIndex: 'status', render: (s) => <Tag color={s === 'active' ? 'green' : 'default'}>{s}</Tag> },
  ];

  return (
    <div>
      {current && (
        <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
          <Col span={6}>
            <Card size="small">
              <Statistic title="当前租户" value={current.tenant?.name} valueStyle={{ fontSize: 16 }} />
            </Card>
          </Col>
          <Col span={6}>
            <Card size="small">
              <Statistic title="园区使用" value={current.stats?.park_count} suffix={`/ ${current.stats?.park_limit}`} />
              <Progress percent={current.stats?.utilization_pct} size="small" />
            </Card>
          </Col>
          <Col span={6}><Card size="small"><Statistic title="用户数" value={current.stats?.user_count} suffix={`/ ${current.stats?.user_limit}`} /></Card></Col>
          <Col span={6}><Card size="small"><Statistic title="套餐" value={current.tenant?.plan} /></Card></Col>
        </Row>
      )}

      <Card
        title="多租户 SaaS 管理"
        size="small"
        extra={<Button type="primary" onClick={() => setCreateOpen(true)}>新建租户</Button>}
      >
        <Table
          loading={loading}
          columns={columns}
          dataSource={list.map((t) => ({ ...t, key: t.id }))}
          pagination={false}
          size="small"
        />
      </Card>

      <Modal title="新建租户" open={createOpen} onCancel={() => setCreateOpen(false)} onOk={handleCreate} okText="创建">
        <Form form={form} layout="vertical">
          <Form.Item name="name" label="租户名称" rules={[{ required: true }]}><Input /></Form.Item>
          <Form.Item name="code" label="租户编码" rules={[{ required: true }]}><Input placeholder="如 QHY-CLIENT-001" /></Form.Item>
          <Form.Item name="plan" label="套餐" initialValue="standard">
            <Select>
              <Select.Option value="trial">试用</Select.Option>
              <Select.Option value="standard">标准</Select.Option>
              <Select.Option value="enterprise">企业</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name="max_parks" label="园区上限" initialValue={3}><InputNumber min={1} max={50} style={{ width: '100%' }} /></Form.Item>
          <Form.Item name="max_users" label="用户上限" initialValue={10}><InputNumber min={1} max={200} style={{ width: '100%' }} /></Form.Item>
          <Form.Item name="contact_person" label="联系人"><Input /></Form.Item>
          <Form.Item name="contact_phone" label="联系电话"><Input /></Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
